import { FetchStatus, Property, PropertyType } from "../../../../base/types";
import { useEffect, useState } from "react";

import { IAsyncBoundProperties } from "../../../../base/hooks";
import { ICardPartProps } from "./ICardPartProps";

export const CardPartProperties = [
    { id: Property.PageLink, name: 'Page Link', type: PropertyType.PageLink },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String }
]

export const useCardPartProperties = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<ICardPartProps>()

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;

        const attributes: ICardPartProps = {
            title: bindings.getValue(Property.Tooltip),
            pageLink: bindings.getValue(Property.PageLink)
        };

        setProperties(attributes)
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties }
}
